import { MessageCircle } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";
import { dictionary } from "../../../utils/dictionary";

const ChatSetup = () => {
  const { language } = useAuth();

  return (
    <div className="flex items-center justify-center h-screen bg-[#F5F6FA]">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <MessageCircle className="w-8 h-8 text-green-600" />
          </div>
        </div>
        <h2 className="text-2xl font-bold mb-3">
          {dictionary["chat-setup-title"][language]}
        </h2>
        <p className="text-gray-500 mb-6">
          {dictionary["chat-setup-subtitle"][language]}
        </p>
        <button
          onClick={() => (window.location.href = "/integrations")}
          className="w-full py-3 px-6 text-white font-semibold rounded-xl transition-all duration-200"
          style={{
            background: "linear-gradient(135deg, #4368E5 0%, #4DB5FF 100%)",
          }}
        >
          {dictionary["chat-setup-cta"][language]}
        </button>
      </div>
    </div>
  );
};

export default ChatSetup;
